module.exports = __webpack_public_path__ + "img/01.eeec7e3c.jpg";